import React from "react";
import type { FormStepProps } from "../../types/application";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../i18n/translations";

const SuccessStep: React.FC<FormStepProps> = ({ data, submissionResult }) => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  return (
    <div className="space-y-6">
      {/* Success Message */}
      <div className="space-y-4">
        {/* <h2 className="text-2xl font-bold text-gray-900">
          {t.applicationSubmittedHeader}
        </h2> */}
        <p className="text-gray-700">
          {t.applicationSubmittedMessage.replace(
            "{firstName}",
            data.firstName || ""
          )}
        </p>
      </div>

      {/* Application Details */}
      <div className="space-y-2">
        <div>
          <strong>{t.applicationIdLabel}</strong> {submissionResult?.applicationId &&
          submissionResult.applicationId !== "unknown"
            ? submissionResult.applicationId
            : t.processing}
        </div>
        <div>
          <strong>{t.applicationSubmittedLabel}</strong> {new Date()
            .toISOString()
            .split("T")[0]}
        </div>
      </div>

      {/* Rating Section */}
      {t.contactHRMessage && (
        <div className="pt-4">
          <p className="text-gray-700 mb-2">{t.contactHRMessage}</p>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex flex-col gap-3 pt-4 items-start">
        <button
          onClick={() => (window.location.href = "/")}
          className="px-4 py-2 border-2 border-[#2B4380] font-medium bg-[#D7E5F5] text-[#2B4380] rounded hover:bg-[#D0DFF0] transition-colors"
        >
          {t.backToHomeButton}
        </button>
        <a
          href="mailto:myfuture-monfutur@forces.gc.ca"
          className="inline-flex items-center justify-center px-4 py-2 border-2 border-gray-300 text-gray-700 rounded hover:bg-gray-50 transition-colors"
        >
          {t.contactHRButton}
        </a>
      </div>
    </div>
  );
};

export default SuccessStep;
